import Vue from 'vue';
import Router from 'vue-router';
import store from '@/store/index';

import { checkLoginStatus } from './router-guard';
import { post } from '@/store/modules/fsm/index';
import PageTitles from '@/constants/page-titles'

import LoginPage from "@/components/public-layouts/LoginPage";
import WelcomePage from "@/components/private-layouts/welcome/WelcomePage";
import WelcomeMedicalReports from "@/components/private-layouts/welcome/WelcomeMedicalReports";
import WelcomeHealthRecords from "@/components/private-layouts/welcome/WelcomeHealthRecords";
import ProviderPage from "@/components/private-layouts/providers/ProviderPage";
import ProvidersPage from "@/components/private-layouts/providers/ProvidersPage";
import ProceduresPage from '@/components/private-layouts/procedures/ProceduresPage';
import DiagnosisPage from '@/components/private-layouts/diagnosis/DiagnosisPage';
import MedicationPage from '@/components/private-layouts/medication/MedicationPage';
import VaccinationPage from '@/components/private-layouts/vaccination/VaccinationPage';
import CdaPage from '@/components/private-layouts/CdaPage';
import CdaContentBody from '@/components/includes/cda/CdaContentBody';
import ReportsPage from '@/components/private-layouts/ReportsPage';
import ReportContentBody from '@/components/includes/report/ReportContentBody';
import PdfsPage from '@/components/private-layouts/PdfsPage';
import PdfContentBody from '@/components/includes/pdf/PdfContentBody';
import WatchPage from '@/components/private-layouts/WatchPage';
import VitalsPage from '@/components/private-layouts/VitalsPage';
import VitalsGroupPage from '@/components/private-layouts/VitalsGroupPage';
import UserProfile from '@/components/private-layouts/UserProfile';
import UserDevices from '@/components/private-layouts/UserDevices';
import UserContacts from '@/components/private-layouts/contact/UserContacts';
import LoadingPage from '@/components/Loading';
import RegisterPage from '@/components/public-layouts/register/RegisterPage';
import PageNotFound from '@/components/private-layouts/404/PageNotFound';
import SearchPage from '@/components/private-layouts/search/SearchPage';
import AllergyPage from '@/components/private-layouts/allergy/AllergyPage';
import FilterableSortablePage from '@/components/includes/FilterableSortablePage';
import ForgotPasswordPage from '@/components/public-layouts/ForgotPasswordPage';
import ResetPasswordPage from '@/components/public-layouts/ResetPasswordPage';
import VerificationPage from '@/components/public-layouts/VerificationPage';
import DataUploadPage from '@/components/private-layouts/DataUploadPage';
import NotesPage from '@/components/private-layouts/NotesPage';
import OrdersPage from '@/components/private-layouts/OrdersPage';
import CurrentDiag from '@/components/private-layouts/currents/CurrentDiag'
import CurrentMed from '@/components/private-layouts/currents/CurrentMed'
import MedAdmin from '@/components/private-layouts/currents/MedAdmin'
import CurrentProc from '@/components/private-layouts/currents/CurrentProc'
import CurrentProviders from '@/components/private-layouts/currents/CurrentProviders'
import CurrentNurse from '@/components/private-layouts/nurses/CurrentNurse';
import PatientNurse from '@/components/private-layouts/nurses/PatientNurse';
import MyAccount from '@/components/private-layouts/myaccount/MyAccount';
import CptBilling from '@/components/private-layouts/CptBilling'
import CptPage from '@/components/private-layouts/CptPage.vue'
import VerifyNursePage from '@/components/public-layouts/VerifyNursePage.vue'
import {
  LoginNavigation,
  RootNavigation,
  WelcomeNavigation,
  ProviderNavigation,
  ProceduresNavigation,
  DiagnosisNavigation,
  MedicationsNavigation, VaccinationNavigation, CdasNavigation, CdaNavigation,
  ReportsNavigation, ReportNavigation, PdfsNavigation, PdfNavigation, WatchNavigation,
  UserProfileNavigation,UserContactNavigation,MedicalReportsNavigation, HealthRecordsNavigation,
  ProvidersNavigation,
  Logout, RegisterNavigation, AdminRegisterNavigation, PageNotFoundNavigation, SearchPageNavigation, AllergyNavigation,
  RequestPasswordResetNavigation, // ForgotPasswordPage
  PasswordResetNavigation, // ResetPasswordPage
  ConfirmRegistrationNavigation, // VerificationPage
  DataUploadNavigation, VitalsNavigation, VitalsGroup, DirectivesNavigation,
  UserDevicesNavigation, NotesNavigation, CurrentProcNavigation, CurrentDiagNavigation, CurrentMedNavigation,
  CurrentProvNavigation, OrdersNavigation,CurrentNurseNavigation,MedAdminNavigation,MyAccountNavigation, CptBillingNavigation,
  CptNavigation, VerifyNurseNavigation, PatientNurseNavigation
} from '@/store/modules/fsm/messages';

if (!process || process.env.NODE_ENV !== 'test') {
  Vue.use(Router)
}
const router = new Router({
  mode: 'hash',
  routes:[
    { path: '/login', component: LoginPage, name: LoginNavigation, meta: {title: PageTitles.TITLE_LOGIN},
      props: route => ({ dest: route.query.dest })
    },
    { path: '/register', component: RegisterPage, name: RegisterNavigation, meta: {title: PageTitles.TITLE_REGISTER} },
    { path: '/adminregister', component: RegisterPage, name: AdminRegisterNavigation, meta: {title: PageTitles.TITLE_REGISTER} },
    { path: '/', component: LoadingPage, name: RootNavigation, meta: {title: PageTitles.TITLE_LOGIN} },
    { path: '/welcome', component: WelcomePage,name: WelcomeNavigation, meta: {title: PageTitles.TITLE_WELCOME} },
    { path: '/notes', component: NotesPage,name: NotesNavigation, meta: {title: PageTitles.TITLE_NOTES} },
    { path: '/cpt', component: CptPage, name: CptNavigation, meta: {title: PageTitles.TITLE_CPT_PAGE} },
    { path: '/cptBilling', component: CptBilling, name: CptBillingNavigation, meta: {title: PageTitles.TITLE_CPT_BILLING} },
    { path: '/orders', component: OrdersPage, name: OrdersNavigation, meta: {title: PageTitles.TITLE_ORDERS} },
    { path: '/medical-reports', name: MedicalReportsNavigation, component: WelcomeMedicalReports, meta: {title: PageTitles.TITLE_WELCOME} },
    { path: '/health-records', name: HealthRecordsNavigation, component: WelcomeHealthRecords, meta: {title: PageTitles.TITLE_WELCOME} },
    { path: '/providers', name: ProvidersNavigation, component: FilterableSortablePage, meta: {title: PageTitles.TITLE_PROVIDERS} },  
    { path: '/vitals', component: VitalsPage, name: VitalsNavigation, meta: { title: PageTitles.TITLE_VITALS}, props: true },
    { path: '/vitalsGroup', component: VitalsGroupPage, meta: { title: PageTitles.TITLE_VITALS}, props: true,
      children: [
        {
          path: ':grouping',
          name: VitalsGroup,
          component: VitalsGroupPage,
          meta: {title: PageTitles.TITLE_VITALS}
        }
      ]},  
    { path: '/provider', component: ProviderPage, meta: {title: PageTitles.TITLE_PROVIDER},
      children: [
        {
          path: ':specialty/:id',
          name: ProviderNavigation,
          component: ProviderPage,
          meta: {title: PageTitles.TITLE_PROVIDER}
        }
      ]
    },
    // { path: '/provider/:specialty/:id', component: ProviderPage,name: ProviderNavigation, meta: {title: PageTitles.TITLE_PROVIDER} },
    { path: '/procedureKinds', component: FilterableSortablePage,name: ProceduresNavigation, meta: {title: PageTitles.TITLE_PROCEDURES} },
    { path: '/diagnosis', component:FilterableSortablePage,name: DiagnosisNavigation, meta: {title: PageTitles.TITLE_DIAGNOSIS} },
    { path: '/medication', component: FilterableSortablePage,name: MedicationsNavigation, meta: {title: PageTitles.TITLE_MEDICATION} },
    { path: '/currentProcedures', component: CurrentProc, name: CurrentProcNavigation, meta: {title: PageTitles.TITLE_CURRENT_PROC}},
    { path: '/currentMedications', component: CurrentMed, name: CurrentMedNavigation, meta: {title: PageTitles.TITLE_CURRENT_MED}},
    { path: '/medAdministration', component: MedAdmin, name: MedAdminNavigation, meta: {title: PageTitles.TITLE_MED_ADMIN}},
    { path: '/currentDiagnosis', component: CurrentDiag, name: CurrentDiagNavigation, meta: {title: PageTitles.TITLE_CURRENT_DIAG}},
    { path: '/currentProviders', component: CurrentProviders, name: CurrentProvNavigation, meta: {title: PageTitles.TITLE_CURRENT_PROV}},
    { path: '/currentNurse', component: CurrentNurse, name: CurrentNurseNavigation, meta: {title: PageTitles.TITLE_CURRENT_NURSE}},
    { path: '/patientNurse', component: PatientNurse, name: PatientNurseNavigation, meta: {title: PageTitles.TITLE_PATIENT_NURSE}},
    { path: '/myAccount', component: MyAccount, name: MyAccountNavigation, meta: {title: PageTitles.TITLE_MY_ACCOUNT}},
      // children: [
      //   path: '/verify',

      // ]
    //},
    { path: '/vaccination//', component: FilterableSortablePage,name: VaccinationNavigation, meta: {title: PageTitles.TITLE_VACCINATION} },
    /*
    { path: '/cdas', component: CdaPage, name: CdasNavigation, meta: {title: PageTitles.TITLE_CDA},
      children: [
        {
          path: ':index/:type?/:id?',
          name: CdaNavigation,
          component: CdaContentBody,
          meta: {title: PageTitles.TITLE_CDA},
          props: true
        },
      ]
    },*/
    {
      name: CdasNavigation,
      path: '/cdas/:selectedCda?/:selectedType?/:selectedId?',
      component: CdaPage,
      props: route => {
        let p = {};
        if(route.params.selectedCda !== undefined) {
          p.selectedCda = Number(route.params.selectedCda);
        }
        if(route.params.selectedType !== undefined) {
          p.selectedType = route.params.selectedType;
        }
        if(route.params.selectedId !== undefined) {
          p.selectedId = Number(route.params.selectedId);
        }
        return p;
      },
      meta: {title: PageTitles.TITLE_PDF}
    },

    /*
    { path: '/reports', component: ReportsPage, name: ReportsNavigation, meta: {title: PageTitles.TITLE_REPORTS},
      children: [
        {
          path: ':index',
          name: ReportNavigation,
          component: ReportContentBody,
          meta: {title: PageTitles.TITLE_REPORTS}
        },
      ]
    },
    */
   {
      name: ReportNavigation,
      path: '/report/:selectedReport',
      component: ReportsPage,
      props: route => {
        if(route.params.selectedReport !== undefined)
          return { selectedReport: Number(route.params.selectedReport) };
        else
          return {};
      },
    meta: {title: PageTitles.TITLE_REPORT},
   },
   { path: '/reports', component:FilterableSortablePage,name: ReportsNavigation, meta: {title: PageTitles.TITLE_REPORTS} },
   /*
    { path: '/pdfs', component: PdfsPage, name: PdfsNavigation, meta: {title: PageTitles.TITLE_PDF},
      children: [
        {
          path: ':index',
          name: PdfNavigation,
          component: PdfContentBody,
          meta: {title: PageTitles.TITLE_PDF}
        },
      ]
    },
    */
    {
      name: PdfsNavigation,
      path: '/pdfs/:selectedPdf?',
      component: PdfsPage,
      props: route => {
        let x = route.params.selectedPdf === undefined ? 
          {} : { selectedPdf : Number(route.params.selectedPdf)};
        return x;
      },
      meta: {title: PageTitles.TITLE_PDF}
    },
    /*
    {
      name: PdfNavigation,
      path: '/pdf/:index',
      component: PdfsPage,
      meta: {title: PageTitles.TITLE_PDF}
     },
     */
    { path: '/data-upload', component: DataUploadPage, name: DataUploadNavigation, meta: {title: PageTitles.DATA_UPLOAD}},
    { path: '/watch', component: WatchPage,name: WatchNavigation, meta: {title: PageTitles.TITLE_WATCH}, props: true},
    { path: '/user/profile', component: UserProfile,name: UserProfileNavigation, meta: {title: PageTitles.TITLE_PROFILE},props:{restricted:true}},
    { path: '/user/contact', component: UserContacts,name: UserContactNavigation, meta: {title: PageTitles.TITLE_CONTACT},props:{restricted:true}},
    { path: '/user/devices', component: UserDevices,name: UserDevicesNavigation, meta: {title: PageTitles.TITLE_DEVICES},props:{restricted:true}},
    { path: '/logout', component: LoginPage, name: Logout, meta: {title: PageTitles.TITLE_LOGIN}},
    { path: '/404', component: PageNotFound, name: PageNotFoundNavigation, meta: {title: PageTitles.TITLE_404}},
    { path: '/search', component: SearchPage, name: SearchPageNavigation, meta: {title: PageTitles.TITLE_SEARCH}},
    { path: '/directives', component: FilterableSortablePage, name: DirectivesNavigation, meta: {title: PageTitles.TITLE_DIRECTIVES}},
    { path: '/allergy', component: FilterableSortablePage, name: AllergyNavigation, meta: {title: PageTitles.TITLE_ALLERGY} },
    { path: '/forgot', component: ForgotPasswordPage, name: RequestPasswordResetNavigation, meta: {title: PageTitles.TITLE_FORGOT} },
    { path: '/reset', component: ResetPasswordPage, name: PasswordResetNavigation, meta: {title: PageTitles.TITLE_RESET}  },
    { path: '/verify', component: VerificationPage, name: ConfirmRegistrationNavigation, meta: {title: PageTitles.TITLE_VERIFY}  },
    { path: '/verifyNurse', component: VerifyNursePage, name: VerifyNurseNavigation, meta: {title: PageTitles.TITLE_VERIFY_NURSE },
      props: route => ({ accountType: route.query.accountType, unique: route.query.unique, accntnum: route.query.accntnum })
    }
  ],
});

// redirect to login page if user is not logged in
router.beforeEach((to, from, next) => {
  // if route is not related to a fsm state/region, skip fsm eval
  // if(Vue.gotInitialMessage)
  //   post({
  //     message: to.name,
  //     toString: ()=>to.name,
  //     to,
  //     from,
  //     next
  //   });
  // else if(to.name === RequestPasswordResetNavigation)
  // {
  //   setTimeout(()=>
  //     post({
  //       message: to.name,
  //       toString: ()=>to.name,
  //       to,
  //       from,
  //       next
  //     }),5000);
  // }
  // else
  // {
  //   next();
  // }
  // document.title = to.meta.title;
  // console.log(to, from)
  console.log(to, from, next)
  checkLoginStatus(to, from, next);
  document.title = to.meta.title
});

export default router;
